import { quoteBusinessAdvisoryText } from "i18n/businessAdvisory";
import {
  heroBusinessConsultingText,
  quoteBusinessConsultingText,
} from "i18n/businessConsulting";
import { quoteConsultingText } from "i18n/consulting";
import { quotePropertyText } from "i18n/property";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const QuoteBusinessConsulting = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = quoteBusinessConsultingText[lang];
  const navigate = useNavigate();

  return (
    <section className="bg-black py-16 px-6">
      {/* Main Quote */}
      <div className="mx-auto border border-white/70 px-6 md:px-16 py-14 md:py-20 text-center">
        <div className="max-w-5xl mx-auto space-y-6">
          {/* Title */}
          <h2
            className="text-white font-semibold leading-tight
                       text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-[Crimson]"
          >
            {t.desc}
          </h2>
        </div>
      </div>
    </section>
  );
};

export default QuoteBusinessConsulting;
